<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_vehicle_temporary"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
        :query="params"
        @on-add="showFormModalDialog"
        @on-batch-del="onBatchDeleteDone"
      />
      <TemporaryVehicleDialog
        :id="entityId"
        :visible="modalForm"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
import { isBefore, getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'
import TemporaryVehicleDialog from './dialog/vehicle-dialog'
export default {
  name: 'TemporaryVehicle',
  components: {
    TableWrapper,
    TemporaryVehicleDialog
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/temporary/parking',
      modalForm: false,
      entityId: 0,
      userName: '',
      modalDelConfirm: false,
      entityName: '',
      modCount: 0,
      garages: this.loadGarages(),
      selection: [],
      timeout: 30000
    }
  },
  computed: {
    updatePermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_PARKING_UPDATE') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_PARKING_DELETE') },
    viewPayPermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_VIEW_PAY') },
    viewTemporaryParkingPermitted() { return isAdmin() || hasPermission('PEM_TEMP_PARKING_DATA_VIEW') },
    params() { return { isTemporary: true } },
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          // { label: '账号', placeholder: '请输入会员账号...', name: 'name', width: 'auto', type: 'input' },
          { label: '姓名', placeholder: '请输入会员姓名...', name: 'user', width: 'auto', type: 'input' },
          { label: '电话号码', placeholder: '请输入会员电话号码...', name: 'mobile', width: 'auto', type: 'input' },
          { label: '临停车库', placeholder: '请选择临停车库...', name: 'parkingId', width: '200px', type: 'select', options: this.garages }
        ]
      }
    },
    columns() {
      const _this = this
      return [
        { title: '姓名', align: 'left', key: 'user', resizable: true, sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.user || '---')
          }
        },
        { title: '电话号码', align: 'left', key: 'mobile', resizable: true, sortable: true, width: 140, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.mobile || '---')
          }
        },
        { title: '临停车库', align: 'left', key: 'parking', resizable: true, sortable: true, ellipsis: true, tooltip: true },

        { title: '过期时间', align: 'center', key: 'expireTime', sortable: true, ellipsis: true, width: 160, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.expireTime || '---')
          }
        },
        { title: '离场时间', align: 'center', key: 'terminateTime', width: 160, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.terminateTime || '---')
          }
        },
        { title: '剩余次数', align: 'center', key: 'remainOpeningTimes', sortable: true, ellipsis: true, tooltip: true, hidden: true },
        { title: '状态', align: 'center', key: '_expire', sortable: true, width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.expireTime && isBefore(params.row.expireTime) ? 'green' : (params.row.expireTime ? 'red' : '#966') }
            }, params.row.expireTime ? (isBefore(params.row.expireTime) ? '未过期' : '已过期') : '---')
          }
        },
        { title: '临停押金', align: 'center', sortable: true, key: 'temporaryDepositPaid', ellipsis: true, tooltip: true, width: 120,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.temporaryDepositPaid === 2 ? 'red' : (params.row.temporaryDepositPaid === 1 ? 'green' : 'red') }
            }, params.row.temporaryDepositPaid === 2 ? '已退费' : (params.row.temporaryDepositPaid === 1 ? '已缴纳' : '未缴纳'))
          }
        },
        { title: '告警数', align: 'center', key: 'reminderTimes', sortable: true, ellipsis: true, tooltip: true, hidden: false, width: 110 },
        { title: '注册时间', align: 'center', sortable: true, hidden: true, key: 'createTime', width: 160, ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 150, disabled: true, key: '_actions',
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.updatePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.updatePermitted) {
                      this.showTemporaryVehicle(params.row.id, params.row.parkingId, params.row.parking)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.deletePermitted ? '编辑临停' : '您没有权限编辑临停' }}, '编辑临停')
              ])
            //   h('a', {
            //     style: getLinkTextStyle(_this.deletePermitted),
            //     on: {
            //       click: () => {
            //         if (params.row.id && _this.deletePermitted) {
            //           this.showDelModalDialog(params.row.id, params.row.name)
            //         }
            //       }
            //     }
            //   }, [
            //     h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
            //     h('span', { domProps: { title: _this.deletePermitted ? '删除临停' : '您没有权限删除临停' }}, '删除临停')
            //   ])
            ])
          }
        }]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showTemporaryVehicle(id, parkingId, parkingName) {
      this.entityId = id
      this.modalForm = true
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除用户信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '临停 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '临停 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.entityName = ''
      this.modalForm = false
      this.modalDelConfirm = false
      this.userName = ''
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    onBatchDeleteDone: function(selections) {
      this.modCount = this.modCount + 1
    }
  }
}
</script>

<style lang="less">
  .avatar {
    img {
      width: 24px;
      height: 24px;
      cursor: zoom-in;
      border: 1px solid #c2bfbf;
    }
  }
</style>
